import { render } from "./InfoRow.vue?vue&type=template&id=a19c94a4&scoped=true&ts=true"
import script from "./InfoRow.vue?vue&type=script&lang=ts"
export * from "./InfoRow.vue?vue&type=script&lang=ts"

import "./InfoRow.vue?vue&type=style&index=0&id=a19c94a4&scoped=true&lang=css"
import "./InfoRow.vue?vue&type=style&index=1&id=a19c94a4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a19c94a4"]])

export default __exports__